import React from 'react'
import { useTranslation } from 'react-i18next'
import DiaptchHolderInformation from './DiaptchHolderInformation'
import { VisitRequestStatus } from 'Application/Visits/Actions/enums'

function VisitDispatchData({ data }: any) {
  // const getColor = () => {
  //   switch (data.status) {
  //     case 1:
  //       return 'info'
  //     case 2:
  //       return 'success'
  //     case 3:
  //       return 'error'
  //     default:
  //       return 'warning'
  //   }
  // }

  const getColor = () => {
    switch (data.status) {
      case 1:
        return 'warning'
      case 2:
        return 'info'
      case 3:
        return 'success'
      case 4:
        return 'error'
      default:
        return 'warning'
    }
  }
  const { t } = useTranslation()

  return (
    <div className="">
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('POLICY_INSURANCE_TYPE_AGREEMENT')}</span>
        <span className="text-sm font-semibold text-gray-800">
          {data?.insuranceTypeTitle || '--'}
        </span>
      </div>

      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('VISIT_STATUS')}:</span>
        <span className={`label label-soft-${getColor()}`}>
          <span className={`label label-soft text-gray-800`}>{t(data.statusTitle)}</span>
        </span>
      </div>

      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('UNIQ_TRACKING_CODE')}:</span>
        <span className={`label label-soft text-gray-800`}>{data.trackingCode}</span>
      </div>
      <br />
      <div className="flex justify-between items-center gap-2">
        <span className="text-base font-bold">{t('HOLDER_INFORMATION')}</span>
      </div>

      <DiaptchHolderInformation data={data} />
    </div>
  )
}

export default VisitDispatchData
